/**
 * moduł niezależny od configa i innych modułów którego możemy używać na etapie bootstrapowania aplikacji
 * wszystkie elementy mogą być
 */
angular.module('lsnBase.bootstrap', []).config(['$locationProvider',
  function($locationProvider) {
    $locationProvider.hashPrefix('');
  }]);